import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trading-history" }
const _hoisted_2 = {
  class: "trading-chart",
  style: {"margin-left":"-16px"}
}
const _hoisted_3 = { class: "trading-filter" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "trading-filter__title" }, "Trading bot statistics for the period:", -1)
const _hoisted_5 = { class: "trading-filter__body" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "trading-stats trading-card card" }
const _hoisted_8 = { class: "trading-card__row" }
const _hoisted_9 = { class: "trading-card__icon trading-card__icon--orange" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "trading-card__title" }, "Total deals:", -1)
const _hoisted_11 = { class: "trading-card__value" }
const _hoisted_12 = { class: "trading-card__row" }
const _hoisted_13 = { class: "trading-card__icon trading-card__icon--green" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "trading-card__title" }, "Successful:", -1)
const _hoisted_15 = { class: "trading-card__value" }
const _hoisted_16 = { class: "trading-card__row" }
const _hoisted_17 = { class: "trading-card__icon trading-card__icon--red" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "trading-card__title" }, "Unsuccessful:", -1)
const _hoisted_19 = { class: "trading-card__value" }
const _hoisted_20 = { class: "trading-card__row" }
const _hoisted_21 = { class: "trading-card__icon trading-card__icon--green" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "trading-card__title" }, "Percentage of profit:", -1)
const _hoisted_23 = { class: "trading-card__value" }
const _hoisted_24 = { class: "trading-main" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "trading-main__title" }, "trading:", -1)

import AnalyticChart from "@/components/AnalyticChart/AnalyticChart.vue";
import Icon from "@/components/Icon/Icon.vue";
import "./TradingHistory.scss";
import TradingHistoryItem from "@/components/TradingHistory/TradingItem/TradingHistoryItem.vue";
import {onMounted, ref, watch} from "vue";
import TradeEntity from "@/entities/TradeEntity";
import {useApiStore} from "@/stores/apiStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradingHistory',
  setup(__props) {


let modes = [
	'24h',
	'3d',
	'7d',
	'1m'
];

let {api} = useApiStore();
let mode = ref<string>(modes[0]);
let trades = ref<TradeEntity[]>([]);
let statistic = ref<{
	success : number,
	failed : number,
	profit : number,
}>({
	success : 0,
	failed : 0,
	profit : 0
});

watch(mode, async () => {

	let response = await api.getTradeStatistic(mode.value);

	statistic.value = response.reduce((result : any, row : any) => {

		if(+row.p < 0){
			result.failed += row.c;
		}else{
			result.success += row.c;
		}

		result.profit += +row.p;

		return result;

	}, {
		profit : 0,
		failed : 0,
		success : 0
	});

}, {immediate: true});

onMounted(async () => {

	let pagination = await api.getTradeHistory(1, 100, {
		field : 'id',
		mode : 'desc'
	});

	trades.value = pagination.items;

});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AnalyticChart, { mode: _unref(mode) }, null, 8, ["mode"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modes), (m) => {
          return (_openBlock(), _createElementBlock("button", {
            class: _normalizeClass(["trading-filter__item", {'trading-filter__item--active' : _unref(mode) === m}]),
            type: "button",
            onClick: ($event: any) => (_isRef(mode) //@ts-ignore
 ? mode.value = m : mode = m),
            key: m
          }, _toDisplayString(m), 11, _hoisted_6))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("i", _hoisted_9, [
          _createVNode(Icon, { name: "rocket" })
        ]),
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(statistic).success + _unref(statistic).failed), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("i", _hoisted_13, [
          _createVNode(Icon, {
            name: "check",
            size: 1.5
          })
        ]),
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(statistic).success), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("i", _hoisted_17, [
          _createVNode(Icon, {
            name: "close",
            size: 1.5
          })
        ]),
        _hoisted_18,
        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(statistic).failed), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("i", _hoisted_21, [
          _createVNode(Icon, { name: "long" })
        ]),
        _hoisted_22,
        _createElementVNode("span", _hoisted_23, _toDisplayString((_unref(statistic).profit * 100).toFixed(2)) + " %", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(trades), (trade) => {
        return (_openBlock(), _createBlock(TradingHistoryItem, {
          trade: trade,
          key: trade.id
        }, null, 8, ["trade"]))
      }), 128))
    ])
  ]))
}
}

})